import React from 'react';

const Arizona = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Arizona Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          No specific disclosure form; checklist format provided by state
          Realtor associations.
        </li>
        <li>
          SPDS Form: Sellers Property Disclosure Statement (SPDS) is required.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>
          Lead-Based Paint Disclosure – Only for residences that were built
          before 1978. This information should be available at the County’s
          Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://consumer.risk.lexisnexis.com/img/Online_Request_Form_Instructions.pdf',
                '_blank'
              );
            }}
          >
            Comprehensive Loss Underwriting Exchange (C.L.U.E.){' '}
          </span>{' '}
          – The seller must provide the buyer with a list of any claims made on
          the property. This can be completed online via LexisNexis, or rights
          can be waived through a waiver form..
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Arizona-Condominium-Addendum-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Condominium Disclosure{' '}
          </span>{' '}
          – Applicable to properties sold within a homeowner's association or
          condominium/planned community.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Arizona-Seller-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Property Disclosure Statement{' '}
          </span>{' '}
          – The seller must disclose known information about the property’s
          condition and any known problems.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Arizona-Seller-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Soil Remediation Disclosure{' '}
          </span>{' '}
          The buyer must be notified if the property has undergone soil
          remediation. This can be mentioned in the Property Disclosure
          Statement.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Arizona-Pool-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Swimming Pool Disclosure{' '}
          </span>{' '}
          – The seller must provide this Department of Health Services notice to
          the buyer when selling a property with a pool
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Arizona-Affidavit-of-Unincorporated-Land-Form.pdf',
                '_blank'
              );
            }}
          >
            Unincorporated Area Disclosure{' '}
          </span>{' '}
          – A special disclosure for sellers of property (five or fewer parcels)
          on unincorporated land.
        </li>
      </ol>
    </div>
  );
};

export default Arizona;
